import { useQuery, useMutation, useQueryClient } from 'react-query';
import {
    GetAllBookings,
    GetBookingById,
    AddNewBooking,
    UpdateBooking,
    DeleteBooking,
    GetBookingsByUser,
    GetBookingsByContract,
    GetBookingsBySeat
} from '../services/backend';
import { Notify, NotifyError } from '../utils/functions';

export function useGetBookings() {
    return useQuery('bookings', () => GetAllBookings(), {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
        select: (data) => {
            return data?.data?.bookings || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch bookings", error);
            console.error("Error fetching bookings:", error);
        }
    });
}

export function useGetBookingById(bookingId, options = {}) {
    return useQuery('booking', () => GetBookingById(bookingId), {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
        select: (data) => {
            return data?.data?.booking || {};
        },
        onError: (error) => {
            NotifyError("Failed to fetch booking", error);
            console.error("Error fetching booking:", error);
        },
        ...options
    });
}

export function useAddBooking() {
    const queryClient = useQueryClient();
    return useMutation('addBooking', (booking) => AddNewBooking(booking), {
        onSuccess: () => {
            Notify("Booking added successfully");
            queryClient.invalidateQueries('bookings');
        },
        onError: (error) => {
            NotifyError("Failed to add booking", error);
            console.error("Error adding booking:", error);
        }
    });
}

export function useUpdateBooking() {
    const queryClient = useQueryClient();
    return useMutation('updateBooking', ({ bookingId, data }) => UpdateBooking(bookingId, data), {
        onSuccess: () => {
            Notify("Booking updated successfully");
            queryClient.invalidateQueries('bookings');
        },
        onError: (error) => {
            NotifyError("Failed to update booking", error);
            console.error("Error updating booking:", error);
        }
    });
}

export function useDeleteBooking() {
    const queryClient = useQueryClient();
    return useMutation('deleteBooking', (bookingId) => DeleteBooking(bookingId), {
        onSuccess: () => {
            Notify("Booking deleted successfully");
            queryClient.invalidateQueries('bookings');
            queryClient.invalidateQueries('contracts');
        },
        onError: (error) => {
            NotifyError("Failed to delete booking", error);
            console.error("Error deleting booking:", error);
        }
    });
}

export function useGetBookingsByUser(userId) {
    return useQuery('bookingsByUser', () => GetBookingsByUser(userId), {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
}

export function useGetBookingsByContract(contractId) {
    return useQuery('bookingsByContract', () => GetBookingsByContract(contractId), {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
}

export function useGetBookingsBySeatId(seatId) {
    return useQuery('bookingsBySeatId', () => GetBookingsBySeat(seatId), {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
        select: (data) => {
            return data?.data?.bookings || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch bookings", error);
            console.error("Error fetching bookings:", error);
        }
    });
}
